"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPronunciationLessonWithProgress = exports.isPronunciationLessonDataList = exports.PronunciationLessonDataListSchema = exports.isPronunciationLessonData = exports.isPronunciationLessonItem = exports.isPronunciationVideoItem = exports.isPronunciationInteractiveTask = exports.isMinimalPairTask = exports.isBasicsOfSpellingTask = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const premade_flashcard_types_1 = require("./flashcard/premade_flashcard_types");
const videos_1 = require("./videos");
const word_types_1 = require("./word/word_types");
const BasicsOfSpellingTaskDataSchema = zod_1.z.object({
    flashcards: premade_flashcard_types_1.AnyNonMinimalPairPremadeFlashcardDefinitionSchema.array(),
    words: word_types_1.SpecialWordSchema.array(),
});
const MinimalPairTaskDataSchema = zod_1.z.object({
    flashcards: premade_flashcard_types_1.MinimalPairFlashcardDefinitionSchema.array(),
});
const BasePronunciationInteractiveTaskSchema = zod_1.z.object({
    id: zod_1.z.number(),
    last_view: zod_1.z.string().optional(),
    name: zod_1.z.string(),
});
const BasicsOfSpellingTaskSchema = BasePronunciationInteractiveTaskSchema.extend({
    data: BasicsOfSpellingTaskDataSchema,
    type: zod_1.z.literal("PRONOUNCE"),
});
exports.isBasicsOfSpellingTask = type_validation_helpers_1.getTypeValidationFunction(BasicsOfSpellingTaskSchema);
const MinimalPairTaskSchema = BasePronunciationInteractiveTaskSchema.extend({
    data: MinimalPairTaskDataSchema,
    type: zod_1.z.literal("EAR_TRAINING"),
});
exports.isMinimalPairTask = type_validation_helpers_1.getTypeValidationFunction(MinimalPairTaskSchema);
const PronunciationInteractiveTaskSchema = zod_1.z.union([
    BasicsOfSpellingTaskSchema,
    MinimalPairTaskSchema,
]);
exports.isPronunciationInteractiveTask = type_validation_helpers_1.getTypeValidationFunction(PronunciationInteractiveTaskSchema);
const PronunciationVideoItemSchema = videos_1.PronunciationVideoSchema.extend({
    type: zod_1.z.literal("VIDEO"),
});
exports.isPronunciationVideoItem = type_validation_helpers_1.getTypeValidationFunction(PronunciationVideoItemSchema);
const PronunciationLessonItemSchema = zod_1.z.union([
    PronunciationVideoItemSchema,
    PronunciationInteractiveTaskSchema,
]);
exports.isPronunciationLessonItem = type_validation_helpers_1.getTypeValidationFunction(PronunciationLessonItemSchema);
const PronunciationLessonDataSchema = zod_1.z.object({
    items: PronunciationLessonItemSchema.array(),
    lesson_id: zod_1.z.number(),
});
exports.isPronunciationLessonData = type_validation_helpers_1.getTypeValidationFunction(PronunciationLessonDataSchema);
exports.PronunciationLessonDataListSchema = PronunciationLessonDataSchema.array();
exports.isPronunciationLessonDataList = type_validation_helpers_1.getTypeValidationFunction(exports.PronunciationLessonDataListSchema);
const PronunciationLessonWithProgressSchema = PronunciationLessonDataSchema.extend({
    progress: zod_1.z.number(),
});
exports.isPronunciationLessonWithProgress = type_validation_helpers_1.getTypeValidationFunction(PronunciationLessonWithProgressSchema);
//# sourceMappingURL=pronunciation_lesson_types.js.map